import React from 'react'
import { withRouter } from 'react-router-dom'
import { Flex } from 'grid-styled'
import { utils } from 'alelo-logic'
import Button from '../../elements/Button'
import Hide from '../../../styles/utilities/Hide'

import { Text, CashDisplay, Currency } from './styles'

import { planTypes } from './data.json'

function renderTitle(recharge) {
  return planTypes[checkPlanType(recharge)].balance
}

const { currencyParser } = utils

const checkPlanType = isPrePaid => (isPrePaid ? 'pre' : 'pos')

const DashboardCashDisplay = ({ recharge, updateDate, value, match, history, isPartner }) => (
  <CashDisplay recharge={recharge}>
    <Text>
      <span className="teste">{renderTitle(recharge)}</span>
      {updateDate}
    </Text>

    <Flex display="flex" direction={['column', 'row']} justify="space-between">
      <Currency>
        <span>R$</span> {currencyParser(value)}
      </Currency>
      {!isPartner && (
        <Hide at="small">
          <Button
            id="btnManual"
            onClick={() =>
              history.push(
                `/minha-veloe/${match.params.id}/${planTypes[checkPlanType(recharge)].buttonAction}`
              )
            }
            text={planTypes[checkPlanType(recharge)].buttonLabel}
          />
        </Hide>
      )}
    </Flex>
  </CashDisplay>
)

export default withRouter(DashboardCashDisplay)



// WEBPACK FOOTER //
// ./src/app/modules/DashboardCashDisplay/index.js